var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PostSearchHeader',{scopedSlots:_vm._u([{key:"header-title",fn:function(){return [_vm._v(" CPT® Code Insights ")]},proxy:true},{key:"header-description",fn:function(){return [_vm._v(" CPT® Code insights to help decipher molecular code descriptions and applications. ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }